export { default as BeamLogo } from './BeamLogo';
export { default as BeamFoundationLogo } from './BeamFoundationLogo';
